import { setupApi } from '@/api/config-setup'
import { queryKeys } from '@/constant/common'
import { SETUP_STATUS } from '@/types'
import { useQuery, QueryOptions, UseQueryResult } from '@tanstack/react-query'

export const useCommonData = (interfaceId: number, queryOptions?: QueryOptions): UseQueryResult<SETUP_STATUS, any>  => {
  return useQuery([queryKeys.setupCommonData, interfaceId],
    async () => {
      const { data } = await setupApi.getCommonData(interfaceId)
      return data
    }, queryOptions)
}

export default useCommonData